/// <summary>
/// This object provides js functions for the Bluaul.VC.Widget.V3.DataCenter.Edit.* <br/>
/// <br/>
/// Author: ARF<br />
/// Date: 9.2.2022<br />
/// Copyright ©: EUDT GmbH 2022 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 4.3.2022                                               *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>
$.widget("bluaul.DsEdit2", $.common.VisualBase, {
    vcC: new vcCommon(),
    vcV: new vcVisual(),
    colWidth: 0,
    day: null,
     bInit:false,
    _create: function () {
        var me = this;
        try {
          
            // set the Visual-Name first
            me.options.invoke.vcvid = 328;
          /*  me.options.invoke.vcgid = Math.floor(Math.random() * Math.floor(1000000));*/

            //initiates the super class
            me._super();

        } catch (e) {
            me.writeError('_create', e);
            return false;
        }
        return true;
    },

    _initHTML: function () {
        var me = this;
     
        try {
            $("body").off("Trigger-DsEdit2_DateCanged");
            $("body").off("Trigger-DsEdit2_FetchSettings");

            me.showMessage("", false);
            if (me.element.find("#div-base-menu .button-toggle").length == 0) { return false; }
          
            me.fnd("#div-sub-content").height(parseInt(me.visual.height() - me.fnd("#div-base-menu").outerHeight(true) - 55));
            me.fnd("#div-base-menu .button-toggle").button();

            me.day = me.settings.parameter.day;
            //we init the vcDate selection ... and start the showChart for the first time
            me.fnd("#div-date").vcDateBox({
                mode: "Single", align: "center", interval: 1, langID: me.settings.userLangIDForCulture, defaultDate: me.day, callback: function (obj) {
                
                    me.day = obj.singleDate;
                  
                    $("body").trigger({ type: "Trigger-DsEdit2_DateCanged",value: me.day});

                }
            });

            me.bInit = true;
        

            me._toggleArchive(me.element.find("#div-base-menu .button-toggle:last"));
            me.element.find("#div-base-menu .button-toggle").off("click").on("click", function () { me._toggleArchive($(this)); });


                   
        } catch (e) {
            me.writeError('_initHTML', e);
            return false;
        }
        return true;
    },

    //not needed here
    _initEvents: function () { return true; },

    _toggleArchive: function (obj) {
        /// <summary>
        /// This function shows/hides divs when changing between chart and settings
        /// </summary>
        var me = this;
        try {

            me.fnd("#div-base-menu .button-toggle").removeClass("button-toggle-active");
            obj.addClass("button-toggle-active");

            me.fnd("#div-sub-content").remove();
            me.element.find(".ds-edit2-base.data-container").append($("<div>").attr("id", "div-sub-content"));
            me.fnd("#div-sub-content").height(parseInt(me.visual.height() - me.fnd("#div-base-menu").outerHeight(true) - 40));
          
            var param = { invokeType: "addVisualBase", parameter: { LoggerId: me.settings.parameter.LoggerId, ShowAnalogEditor: me.settings.parameter.ShowAnalogEditor, bsaid: me.settings.parameter.bsaid, day: me.day, AqsParameter: me.specific.StartParameter.AqsParameter } };
          

            if (obj.attr("id") == "div-btn-raw") {

                me.fnd("#div-sub-content").DsEditRaw2(param);
     
            } else {
                me.fnd("#div-sub-content").DsEditArchive2(param);
            }


        } catch (e) { me.writeError('_toggleArchive', e); return false; }
        return true;
    },


    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) {
                me.fnd("#div-base-menu, #div sub-content").hide();
            }
            return true;
        } catch (e) {
            me.writeError('specificInfoHandling', e); return false;
        }
    },


    destroy: function () {
        try {

            this.vcV.destroyRampChart("999990");
            this.vcV.destroyRampChart("999992");
            this.vcV.destroyRampChart("999993");
            this.vcV.destroyRampChart("999993");
            this.vcV.destroyRampChart("999995");

            this._super(); 

            // remove #div-dialog.ds-edit2 element, otherwise it will stay there forever
            $('.ds-edit2').closest('#div-dialog').removeData().remove();

            // TODO MKU: check if there could be any influence on other parts???
            $('.logs-popup').closest(".ui-dialog").removeData().remove();

            // remove all eventListeners
            $('body').off(this.eventNamespace); // remove all body event listeners
            $('body').off("click" + this.eventNamespace); // remove all click event listeners on body
            $(document).off("click" + this.eventNamespace); // remove all click event listeners on document
            $(this.element).off(); // remove all event listeners on element
            $(this).off(this.eventNamespace);

            // iterate all properties of this and remove everything and set it to null
            for (var key in this) {
                if (this.hasOwnProperty(key)) {
                    if (key != 'element' && key != 'bindings' && key != 'container') {
                        if (this[key] && this[key].jquery) {
                            $(this[key]).removeData().remove(); // remove jQuery data and DOM element
                            this[key] = null; // set reference to null
                        } else {
                            this[key] = null; // not-jquery property are also set to null
                        }
                    }

                }
            }

            // remove all bindings and general element itself
            this.bindings = null;
            this.container = null;
            this.element = null;

            $(this.bindings).remove();
            $(this.container).remove();
            $(this.element).remove();

        } catch (e) {
            me.writeError('destroy', e); return false;
        }
    }

});


/// <summary>
/// This object provides js functions for the Bluaul.VC.Widget.V3.DataCenter.Edit.* <br/>
/// <br/>
/// Author: ARF<br />
/// Date: 9.2.2022<br />
/// Copyright ©: EUDT GmbH 2022 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 4.3.2022                                               *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>
$.widget("bluaul.DsEditTemplate2", $.common.VisualBase, {
    vcgid: -1,
    rowHeight: 30,
    colWidth: 0,
    digitNumber: 5,
    divList: null,
    divChart: null,
    chart: null,
    btnSave: null,
    chartHeight: 0,
    chartWidth: 0,
    chartVcgid: 0,
    editChartVcgid: 0,
    copyChartVcgid: 0,
    rowHeightFactor: 1,
    currentDate: null,
    settingDates: null, //container for the settings vcDate selection 
    settingsListDateFormat: "DD.MM.YYYY",
    bInitSettings: false,
    othersChartType:"",
    vcC: new vcCommon(),
    vcV: new vcVisual(),


    _create: function () {
        var me = this;
        try {

            me.element.html("");
            // set the Visual-Name first
            me.options.invoke.vcvid = me.vcgid;
            me.options.invoke.vcgid = Math.floor(Math.random() * Math.floor(1000000));

            //initiates the super class
            me._super();

        } catch (e) {
            me.writeError('_create', e);
            return false;
        }
        return true;
    },

    _initHTML: function () {
        var me = this;

        try {

         
           // if (typeof (gc999990) != "undefined") { gc999990(); }
       
            me.showMessage("", false);
            me.chartHeight = parseInt(me.visual.height() - me.fnd("#div-menu").outerHeight(true));
            me.chartWidth = parseInt(me.fnd("#div-chart").width() - me.fnd("#div-right-frame").width() - 20);
            me.fnd("#div-chart,#div-settings, #div-others").height(me.chartHeight - 10);
            me.fnd("#div-chart").width(me.chartWidth);

            me.fnd("#div-settings-list").height(me.chartHeight - 150);

            _VCMQ.addConsumer(999990);
            _VCMQ.consume($(me.visual), 999990, function (e) { me._doEvent(e) });


            //alert(me.specific.isAdmin);


            //we init the edit dialog
            me._initEditDialog(0.97, 0.96, "ds-edit2", function () { me._showBaseChart(); }, true);

            me._addEditFormMenuAndValidation();


            me.currentDate = me.settings.parameter.day;

            me._showExtendedConfig();

            me._showBaseChart();

            me.fnd("#div-reload").off("click").on("click", function () {

                me.fnd("#div-edit-settings,#div-menu .others").removeClass("button-toggle-active");
                me.fnd("#div-chart, #div-right-frame, #div-bottom-frame").show();
                me.fnd("#div-settings").hide();
                me.fnd("#div-others").hide().html("");
                me._showBaseChart();
            });


            me.fnd("#div-menu .others").off("click").on("click", function () {
                me._toggleOthers($(this));
            });


            var sTasks = "<select id='ddl-send-tasks' class='ddl' style='padding:4px' ><option value='0'>importData</option><option value='1'>delData</option><option value='2'>recalcData</option><option value='3'>getData</option></select>";
            me.visual.find(".vc-tasks-send").vcOptionBox({
                caption: me.specific.resources.tasks,
                items: [{ button: sTasks + "<div id='btn-send-tasks' class='button-toggle'>" + me.specific.resources.send + "</div>", content: $("<div>").attr("id", "vc-cal-tasks"), isList: false }]
            });
            me.fnd("#vc-cal-tasks").vcDate({ mode: "Range", interval: 1, langID: me.UserLangIDForCulture, defaultRange: { from: me.currentDate, to: me.currentDate } });

            me.fnd("#btn-send-tasks").off("click").on("click", function () {
                me._sendTasks();
            });

            me._initSettings();
            me.getConfigDirtyStatus();

            $("body").on("Trigger-DsEdit2_DateCanged", function (e) {
                me.currentDate = e.value;
                me.settings.parameter.day = me.currentDate;

                if (me.othersChartType == "") {
                    me._showBaseChart();
                } else {
                    me._loadOthers();
                }
            });


        } catch (e) {
            me.writeError('_initHTML', e);
            return false;
        }
        return true;
    },

    //not needed here - everyhting done in _addEditFormMenuAndValidation
    _initEvents: function () { return true; },

    //must override in sub visual
    _setValueFromChartPoint: function (selectedChartIndex) { return true; },
    //must override in sub visual
    _setChartPointFromValue: function (selectedChartIndex) { return true; },
    //must override in sub visual
    _getSelectedIndex: function (selectedChartIndex) { return -1; },
    //must override in sub visual
    _addLine: function (row, selected) { return false; },
    //must override in sub visual
    _addHeader: function (text, date) { return ""; },
    //must override in sub visual
    _showBaseChart: function () { return true; },
    //must override in sub visual
    _showEditChart: function () { return true; },

    //must override in sub visual
    _getZstDiff: function () { return true; },

    _calcNewArchiveSum: function () { return true; },

    _showExtendedConfig: function () {
        /// <summary>
        /// This function loads the extended config into the right frame
        /// </summary>
        var me = this;
        try {

            var divRightFrame = me.fnd("#div-right-frame");
            var cr = me.getRandomIDContainerObj(divRightFrame.attr("id") + "-1-", true);
            divRightFrame.append(cr.obj);
            cr.obj.width(parseInt(divRightFrame.width()));
            cr.obj.height(parseInt(divRightFrame.height()));
            cr.obj.SignalAnalogExtendedConfig({ invokeType: "addVisualBase", parameter: { bsaid: me.settings.parameter.bsaid, LoggerId: me.settings.parameter.LoggerId, UseInDataCenter: true } });
        } catch (e) {
            me.writeError('_showExtendedConfig', e);
        }
    },


    _showChart: function (vcgid, divChart, chartName, specificParam, bsaid, day, edit, showLegend) {
        /// <summary>
        /// This function loads all different charts
        /// </summary>
        var me = this;
        var param;


        try {
           
            me.container = {}
            me.container.random = vcgid;
            me.container.prefix = divChart.attr("id") + "-" + chartName + "-";
            me.container.obj = $("<div>").attr("id", me.container.prefix + me.container.random);

            divChart.html(me.container.obj);
            me.container.obj.width(parseInt(divChart.width()));
            me.container.obj.height(parseInt(divChart.height()));
            me.container.obj.html(me.getLoadingIcon());

            var aqsParameter = me.specific.StartParameter || {
                DataCenterStart: false,
                ShowInvalid: true,
                ShowInplausible: true,
                ShowMissing: true,
                ShowRules: true,
                IgnoreNotTagBasedValidation: false
            };

            var defaultParam = {
                'loggerID': me.settings.parameter.LoggerId, 'UsePrices': false, 'HideLegend': showLegend == false, 'UseSimpleBottomLegend': showLegend, 'NoZoom': true,
                'GetSingleValuesAsConsumption': false, 'ShowInvalidValues': true, 'ShowPlotLines': true, 'ShowIntervention': false,
                'ShowEmptyChart': true, 'ShowExportIcons': true, 'DataType': 1, 'DateuserDef': true, 'AqsParameter': aqsParameter
            }
            var param = $.extend({}, defaultParam, specificParam);


            param.startDate = day;
            param.endDate = day;


            var signalParam = {
                'series': [{ 'bsaid': [bsaid], 'rule': '[bsaid=' + bsaid + ']', 'ruleType': 1, 'edit': edit }]
            };



            me.vcV.addRampBaseByName(me.container.prefix, chartName, me.container.random, me.currentDate, me.container.obj.height(), me.container.obj.width() - 10, JSON.stringify(param), JSON.stringify(signalParam), me.settings.deviceType);

            return me.container.random;
        } catch (e) { me.writeError('showChart', e); return -1; }

    },

    _fetch: function (selectedChartIndex) {
        /// <summary>
        /// This function fetches existing entries
        /// </summary>
        var me = this;
        try {
         
            var param = { typeid: 1, bsaid: me.settings.parameter.bsaid, day: me.currentDate }
          
            me.getData(param, function (result) {

                //check response content
                if (result == null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return true;
                }
                me.data = result;
                //let's build the edit form
                me._showEditForm(selectedChartIndex);

                me._getZstDiff();





                return true;
            });

        } catch (e) { me.writeError('fetch', e); return false; }
        return true;
    },

    _addEditFormMenuAndValidation: function () {
        /// <summary>
        /// We init everything we need for the editor popup form
        /// </summary>
        var me = this;
        var w, h;
        try {

            //we get some height and width
            w = me.editDialog.width - 27;
            h = me.editDialog.height - 100;
            var div = me.fnd("#tpl-edit div:first");
            div.width(w).height(h);

            h -= 40;   //subtract the header

            me.divList = div.find("#div-edit-list").width(w).height(h);
            me.divChart = div.find("#div-edit-chart").width(w).height(h).hide();
            div.find("#div-edit-chart-top").width(w).height(parseInt(h * 0.37));
            div.find("#div-edit-chart-bottom").width(w).height(parseInt(h * 0.61));
            //and we hide the edit menu (we only need it for archive values)
            var menu = div.find("#div-edit-list-menu").hide();
            menu.find(".button-toggle").button();


            me.editDialog.html(div);

            //we add the event handler for the back button and save button
            div.find("#div-back").button().off("click").on("click", function () {
                if (div.find(".line.dirty").length > 0) {
                    me.openAskDialog(me.specific.resources.shouldChangesGetApplied, { at: 'center center-20%', of: window },
                        function () { me._save(); _VCMQ.produce($(me.visual), me.options.invoke.vcgid, 'CLOSE_EDIT_DIALOG', ""); },
                        function () { _VCMQ.produce($(me.visual), me.options.invoke.vcgid, 'CLOSE_EDIT_DIALOG', ""); });
                } else {
                    _VCMQ.produce($(me.visual), me.options.invoke.vcgid, 'CLOSE_EDIT_DIALOG', "");
                }

            });
            me.btnSave = div.find("#div-save").button().button("disable").off("click").on("click", function () {
                me._save($("#div-edit-list"));
                _VCMQ.produce($(me.visual), me.options.invoke.vcgid, 'CLOSE_EDIT_DIALOG', "");
            });

            ////we init the validation events for vals and checkboxes

            me.divList.off("paste keyup", ".col .val").on("paste keyup", ".col .val", function () {

                let obj = $(this);
                setTimeout(function () {
                    if (me._validate(obj)) {
                        //this is only used for archive values
                        me._setChartPointFromValue(parseInt(obj.data("id")) - me.shiftArchiveIndex, parseInt(obj.val()));
                        me.btnSave.button("enable");
                    } else {
                        me.btnSave.button("disable");
                    }
                }, 100);

            });
            //well, this checkbox is not really used currently ... hm ...
            me.divList.off("change", ".col .chk").on("change", ".col .chk", function () {
                if (me._validateChk($(this))) {
                    me.btnSave.button("enable");
                } else {
                    me.btnSave.button("disable");
                }
            });

        } catch (e) {
            me.writeError('_addEditFormMenuAndValidation', e);
            return false;
        }
        return true;
    },

    _setColsInEditForm: function () {
        /// <summary>
        /// sets the cols in the edit form
        /// </summary>
        var me = this;
        try {

            //build the column list
            return parseInt(me.divList.width() / me.colWidth);
                  } catch (ex) { me.writeError('_setColsInEditForm', ex); }
    },

    _showEditForm: function (selectedChartIndex) {
        /// <summary>
        /// Opens the data editor popup
        /// </summary>
        var me = this;

        var i;
        try {

            if (me.specific.isRule) {
                alert(me.specific.resources.rulesCannotGetEdited);
                return;
            }

            me.divList.html("");

            //build the column list
            var cols = parseInt(me.divList.width() / me.colWidth);

            var lstCols = [];

            for (var i = 0; i < cols; i++) {
                lstCols.push($("<div>").addClass("col current-date"));
            }

            //get the data index of the selected chart value
            var selectedIndex = me._getSelectedIndex(selectedChartIndex);

            //get the number of rows
            var rows = parseInt(me.divList.height() / me.rowHeight);
        
            rows = parseInt(rows * me.rowHeightFactor);

            rows = rows - 1; //we need one line for the header
            var row = rows; //store one single row

            //get the half of the shown entries
            var half = parseInt((cols * rows) / 2);
            //we want to selected entry in the middle of the list, so we start half way
            var startRow = parseInt(selectedIndex - half);

            //if we cannot show everything at once
            if (me.data.length > (rows * cols)) {
                if (me.data.length > (selectedIndex + half)) {
                    if (startRow > 0) {
                        rows = startRow + row;
                    }
                } else {
                    //we handle the end of the list separately
                    rows = me.data.length - (half + row);
                }

            } else {
                //if we have less values as we can show - we start with the first
                rows = row;

            }

            //now we fill the list
            for (var j = 0; j < cols; j++) {
                var dt = "";
                lstCols[j].append(me._addHeader(dt, dt));

                for (i = (rows - row); i < rows; i++) {

                    if (i < rows && (i < me.data.length)) {
                        lstCols[j].append(me._addLine(me.data[i], i == selectedIndex));
                    }
                }
                rows = rows + row;
            }

            me.divList.html(lstCols);

            //we set the columns widths
            me.divList.find(".col").css("width", (100 / cols) + "%");

            me._showEditChart();

       
            me.editDialog.dialog("open");


        } catch (ex) { me.writeError('showEditForm', ex); }
    },

    _validate: function (obj) {
        /// <summary>
        /// This function validates analog values adn sets the line to dirty if the value has changed
        /// </summary>
        var me = this;
        var val, oldVal;
        var valid = false;
        try {


            val = me.vcC.cleanNumber(obj.val());
            oldVal = me.vcC.cleanNumber(obj.data("oldVal"));

            if (val.length === 0) {
                if (!obj.hasClass("empty")) { obj.addClass("empty") };
                valid = false;
            } else {
                obj.removeClass("empty");
                valid = true;
            }
            if (valid) {
                if (validateNumeric(val) === false || isNaN(parseFloat(val))) {
                    if (!obj.hasClass("err")) { obj.addClass("err") };
                    valid = false;
                } else {
                    obj.removeClass("err");
                    valid = true;
                }
            }
            if (!valid) {
                obj.siblings(".icon").html("<i class='fa fa-exclamation-triangle icon-color-error'></i>");
            } else {
                obj.siblings(".icon").html("");
            }

            //if (val !== oldVal) {
                if (!obj.parents(".line").hasClass("dirty")) { obj.parents(".line").addClass("dirty") };
                obj.siblings(".icon").html("<i class='fa fa-check icon-color-info'></i>");
            //} else {
            //    obj.parents(".line").removeClass("dirty");
            //}

            me._calcNewArchiveSum();


            return valid;

        } catch (e) { me.writeError('validate', e); return false; }
        return false;
    },

    _validateChk: function (obj) {
        /// <summary>
        /// This function validate the ignore checkbox and sets the line dirty if something has changed
        /// </summary>
        var me = this;
        var val, oldVal;
        var valid = false;
        try {


            val = me.vcC.cleanNumber(obj.prop("checked"));
            oldVal = me.vcC.cleanNumber(obj.data("oldVal"));

            if (val !== oldVal) {
                if (!obj.hasClass("dirty")) { obj.addClass("dirty") }
                if (!obj.parents(".line").hasClass("dirty")) { obj.parents(".line").addClass("dirty") };

                obj.siblings(".icon").html("<i class='fa fa-check icon-color-info'></i>");
            } else {
                obj.siblings(".icon").html("");
                obj.parents(".line").removeClass("dirty");
                obj.removeClass("dirty");
            }

            return true;

        } catch (e) { me.writeError('validate', e); return false; }
        return false;
    },

    _save: function () {
        /// <summary>
        /// This function saves everything
        /// </summary>
        var me = this;
        try {

            var dataList = [];
            var lastDate = "";
            me.divList.find(".line.dirty").each(function () {
                var l = $(this);
                var id = (parseInt(l.find(".val").data("id")));

                if (l.data("date") != lastDate) {
                    dataList.push({ bsaid: me.settings.parameter.bsaid, day: l.data("date"), valueList: [] });
                    dataList[dataList.length - 1].valueList.push({
                        id: id,timestamp: l.find(".time").html(),
                        valNew: me.vcC.cleanNumber(l.find(".val").val()).replace(",", "."),
                        valOld: me.vcC.cleanNumber(l.find(".val").data("oldVal")).replace(",", "."),
                        ignore: l.find(".chk").prop("checked"),
                        ignoreOld: l.find(".chk").data("oldVal")
                    });
                    lastDate = l.data("date");
                } else {
                    dataList[dataList.length - 1].valueList.push({
                        id: id, timestamp: l.find(".time").html(),
                        valNew: me.vcC.cleanNumber(l.find(".val").val()).replace(",", "."),
                        valOld: me.vcC.cleanNumber(l.find(".val").data("oldVal")).replace(",", "."),
                        ignore: l.find(".chk").prop("checked"),
                        ignoreOld: l.find(".chk").data("oldVal")

                    });
                }

            });
            if (dataList.length == 0) { return true; }



            me.updateData({ typeid: 1, day: me.currentDate, DataList: dataList }, function (result) {
                if (result == null) {
                    me.showMessage(me.resources.err_saveData, true);
                    return true;
                }
                if (result == false) {
                    me.showMessage(me.resources.err_saveData, true);
                    return true;
                }
                me._showBaseChart();

                return true;
            });

        } catch (e) { me.writeError('save', e); return false; }
        return true;
    },

    _toggleOthers: function (obj) {
        /// <summary>
        /// This function shows/hides divs when changing between chart and settings
        /// </summary>
        var me = this;
        try {

            if (obj.hasClass("ignore-rule")) return true;

            if (obj.hasClass("button-toggle-active")) {

                obj.removeClass("button-toggle-active");
                me.fnd("#div-chart, #div-right-frame,#div-bottom-frame").show();
                me.fnd("#div-others").hide();

                //always reload the config status
                if (obj.data("type") == "configdirty") me.getConfigDirtyStatus();

                me.othersChartType = "";

            } else {
                me.fnd("#div-edit-settings, #div-menu .others").removeClass("button-toggle-active");
                obj.addClass("button-toggle-active");
                me.fnd("#div-chart,#div-right-frame, #div-bottom-frame, #div-settings").hide();

                me.othersChartType = obj.data("type");
                me._loadOthers();

            }


        } catch (e) { me.writeError('toggleSettings', e); return false; }
        return true;
    },

    _loadOthers: function () {
        /// <summary>
        /// This function shows different charts or visuals
        /// </summary>
        var me = this;
        try {

                var visualname = "";
                var sParameter = "";
                var sSignalParameter = "";
                var param = { 'loggerid': me.settings.parameter.LoggerId, 'day': me.currentDate, 'bsaid': [me.settings.parameter.bsaid] };


                var c = me.getRandomIDContainerObj("div-others-", true);
                c.obj.height(me.fnd("#div-others").height());
                me.fnd("#div-others").html(c.obj).show();

            switch (me.othersChartType) {
                    case "plaus":

                        visualname = "VISUAL_DATACENTER_MULTI_PLAUS";
                        sParameter = JSON.stringify(param);
                        break;
                    case 'singleedit':
                        visualname = "VISUAL_DATACENTER_SPLIT_PEAKS";
                        sParameter = JSON.stringify(param);
                        break;

                    case 'rangeedit':
                        visualname = "VISUAL_DATACENTER_EDIT_RANGE";
                        sParameter = JSON.stringify(param);
                        break;


                    case 'intervention':
                        visualname = "VISUAL_FORM_INTERVENTION";
                        sParameter = 'true,-1,' + me.settings.parameter.LoggerId;

                        break;

                    case 'activity':
                    //TODO: MKU - CHANGE ACTIVITIES HERE - showOverview = false, given blid, all user, edit = true, isSeen = false

                    var p = {
                        UserId: 0,
                        Editable: true,
                        ShowOverview: false,
                        StartWithOverview: false,
                        isSeen: false,
                        BillingMode: false,
                        TimeRange: 3,
                        StartDate: me.currentDate,
                        HideDateBox: true
                    };

                    me.fnd("#div-others").Activities({ invokeType: "addVisualBase", parameter: p });

                    //visualname = "VISUAL_FORM_ACTIVITY";
                        break;

                    case 'ticket':
                  
                    me.fnd("#div-others").TicketList({ invokeType: "addVisualBase", parameter: { "ReadOnlyMode": false, 'SignalID': me.settings.parameter.bsaid, "LoggerID": me.settings.parameter.LoggerId }, deviceType: me.settings.deviceType });


                        break;

                    case "status":
                        visualname = "VISUAL_DATACENTER_ARCHIVESTATUS";
                        sParameter = JSON.stringify(param);
                        c.obj.width(c.obj.width() - 10);
                        break;


                    case "config":
                        visualname = "VISUAL_UNIT_ANALOG_EDITOR";
                        param.FilterBsaid = me.settings.parameter.bsaid;
                        sParameter = JSON.stringify(param);
                        break;
                    case "configdirty":
                        visualname = "VISUAL_UNIT_CONFIGCOMMIT";
                        param.bsaid = -1;
                        sParameter = JSON.stringify(param);

                        //reload the config status
                        me.getConfigDirtyStatus();
                        break;

                    case 'heatmap':

                        var dtStart = moment(me.currentDate, 'DD.MM.YYYY').add(-2, 'M').format('DD.MM.YYYY');

                        //send the config for the share url
                        var p1 = {

                            bsaid: me.settings.parameter.bsaid,
                            startDate: dtStart,
                            endDate: me.currentDate,
                            interval: 1,

                            DataType: 2,
                            LoggerId: me.settings.parameter.LoggerId,
                            isStandAlone: false
                        };

                        me.fnd("#div-others").Heatmap({ invokeType: "addVisualBase", parameter: p1, deviceType: me.settings.deviceType });

                        break;

                    case 'autocheck':

                        c.obj.AutoCheckOverview({ invokeType: "addVisualBase", parameter: { 'LoggerId': me.settings.parameter.LoggerId, 'bsaid': me.settings.parameter.bsaid } });
                        break;


                    case "info":

                        visualname = "VISUAL_SIGNALANALOG_SUMMARY";
                        sSignalParameter = JSON.stringify({ 'bsaid': me.settings.parameter.bsaid, 'UseInDataCenter': true });

                        break;

                    default: break;
                }


                if (visualname.length === 0) { return false }


                me.vcV.addVisualBaseByName(c.prefix, visualname, c.random, me.currentDate, c.obj.height(), c.obj.width() - 10, sParameter, sSignalParameter, me.settings.deviceType);


        } catch (e) { me.writeError('loadSettings', e); return false; }
        return true;
    },


    _initSettings: function () {
        /// <summary>
        /// We init the settings menu ...
        /// </summary>
        var me = this;
        try {

          

            //we init the vcDateBox for the settings and store the default values in the me.settingsDates obj.
            me.fnd("#div-date-settings").vcDateBox({
                mode: "Range", align: "right", interval: 1, langID: me.settings.userLangIDForCulture, defaultRange: { from: me.currentDate, to: me.currentDate }, callback: function (obj) {
                    me.settingDates = obj.dateRange;
                    if (me.bInitSettings) me._fetchSettings();
                    me.bInitSettings = true;
                }
            });

            //we fill the data type option box
            var tmp = me.element.find("#div-settings .select-datatype").clone().css("width", "100%");
            me.element.find("#div-settings .select-datatype").replaceWith($("<div>", { "class": "select-datatype-box vc-grid-1col  vc-grid-margin-right" }));
            me.element.find("#div-settings .select-datatype-box").vcOptionBox({
                caption: me.resources.selection, items: [{ button: me.specific.resources.datatype_lbl, clickable: false, isList: true, content: tmp }]
            });
            //we fill the dims option box
            tmp = me.element.find("#div-settings .select-dims").clone().css("width", "100%");
            me.element.find("#div-settings .select-dims").replaceWith($("<div>", { "class": "select-dims-box vc-grid-1col  vc-grid-margin-right" }));
            me.element.find("#div-settings .select-dims-box").vcOptionBox({
                caption: me.resources.selection, items: [{ button: me.specific.resources.dims, clickable: false, isList: true, content: tmp }]
            });

            //we fill the hr/raw data level option box
            tmp = me.element.find("#div-settings .select-level").clone().css("width", "100%");
            me.element.find("#div-settings .select-level").replaceWith($("<div>", { "class": "select-level-box vc-grid-1col  vc-grid-margin-right" }));
            me.element.find("#div-settings .select-level-box").vcOptionBox({
                caption: me.resources.selection, items: [{ button: me.specific.resources.dataLevel, clickable: false, isList: true, content: tmp }]
            });

            //we fill the value option box
            tmp = me.element.find("#div-settings .txt-edit-value").clone().css("width", "80%");
            me.element.find("#div-settings .txt-edit-value").replaceWith($("<div>", { "class": "txt-edit-value-box vc-grid-1col  vc-grid-margin-right" }));
            me.element.find("#div-settings .txt-edit-value-box").vcOptionBox({
                caption: me.specific.resources.input, items: [{ button: me.specific.resources.value, clickable: false, isList: false, content: tmp }]
            });


            me.fnd("#div-edit-settings").off("click").on("click", function () { me._toggleSettings() });
            me.fnd("#div-save-settings").off("click").on("click", function () { me._saveSettings() });

            //we have to show/hide different option boxes based on the select data type
            me._toggleSettingsDataType();
            me.element.find("#div-settings .select-datatype").off("change").on("change", function () { me._toggleSettingsDataType(); });

            //validation of the mkorr edit value
            me.element.find("#div-settings .txt-edit-value").off("keyup").on("keyup", function () {
                val = me.element.find("#div-settings .txt-edit-value").val();
                val = me.vcC.cleanNumber(val);

                if (val.length === 0 || validateNumeric(val) === false || isNaN(parseFloat(val))) {
                    if (!me.element.find("#div-settings .txt-edit-value").hasClass("err")) { me.element.find("#div-settings .txt-edit-value").addClass("err") };
                    me.element.find("#div-save-settings").removeClass("active");

                } else {
                    me.element.find("#div-settings .txt-edit-value").removeClass("err");
                    if (!me.element.find("#div-save-settings").hasClass("active")) { me.element.find("#div-save-settings").addClass("active") };
                }

            });

        } catch (e) {
            me.writeError('_initSettings', e);
            return false;
        }
        return true;
    },

    _toggleSettings: function () {
        /// <summary>
        /// This function shows/hides divs when changing between chart and settings
        /// </summary>
        var me = this;
        try {
            if (me.fnd("#div-edit-settings").hasClass("button-toggle-active")) {

                me.fnd("#div-edit-settings").removeClass("button-toggle-active");
                me.fnd("#div-chart, #div-right-frame,#div-bottom-frame").show();
                me.fnd("#div-settings").hide();
            } else {
                me.fnd("#div-menu .others").removeClass("button-toggle-active");
                me.fnd("#div-edit-settings").addClass("button-toggle-active");
                me.fnd("#div-chart,#div-right-frame, #div-bottom-frame, #div-others").hide();
                me.fnd("#div-settings").show();
                me._fetchSettings();
            }


        } catch (e) { me.writeError('toggleSettings', e); return false; }
        return true;
    },

    _toggleSettingsDataType: function () {
        /// <summary>
        /// This function shows/hides settings when changing between the setting type
        /// </summary>
        var me = this;
        try {
            var type = parseInt(me.element.find("#div-settings .select-datatype").val());

            switch (type) {
                case 1:    //mkorr;
                    me.fnd(".select-dims-box").hide();
                    me.fnd(".select-level-box").hide();
                    me.fnd(".txt-edit-value-box").show();
                    break;
                case 2:    //bdimsid;
                    me.fnd(".select-dims-box").show();
                    me.fnd(".select-level-box").hide();
                    me.fnd(".txt-edit-value-box").hide();
                    break;
                case 3:    //hr datalevel;
                    me.fnd(".select-dims-box").hide();
                    me.fnd(".select-level-box").show();
                    me.fnd(".txt-edit-value-box").hide();
                    break;

                default:
            }
            me._fetchSettings();

        } catch (e) { me.writeError('_toggleSettingsDataType', e); return false; }
        return true;
    },

    _fetchSettings: function () {
        /// <summary>
        /// This function fetches existing settings based on the settings menu
        /// </summary>
        var me = this;
        try {

            if (!me.fnd("#div-edit-settings").hasClass("button-toggle-active")) {
                return false;
            }
           // alert(me.settings.parameter.bsaid);
            var type = parseInt(me.element.find("#div-settings .select-datatype").val());

            var param = { typeid: 2, bsaid: me.settings.parameter.bsaid, day: me.currentDate, settings: { typeId: type, StartDate: me.settingDates.from, EndDate: me.settingDates.to } }

            me.getData(param, function (result) {
                //check response content
                if (result == null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return true;
                }


                me._showSettingsList(result);

                return true;
            });

        } catch (e) { me.writeError('_fetchSettings', e); return false; }
        return true;
    },

    _showSettingsList: function (data) {
        /// <summary>
        /// This function fetches existing entries and builds a simple list below the setting menu
        /// </summary>
        var me = this;
        try {

            var list = me.fnd("#div-settings-list");
            var val;
            list.html("");

            if (data.rows == null) { return true; }


            for (var i = 0; i < data.rows.length; i++) {
                val = data.rows[i]["val"] + "";
                val = val.replace(".", ",");
                list.append(moment(data.rows[i]["timestamp"], me.settingsListDateFormat).format(me.settingsListDateFormat) + ": " + val + "<br/>");
            }


        } catch (e) { me.writeError('_showSettingsList', e); }

    },

    _saveSettings: function (list) {
        /// <summary>
        /// This function saves the new settings
        /// </summary>
        var me = this;
        try {
            var lst = [];
            var id;

            if (!me.element.find("#div-save-settings").hasClass("active")) { return false; }

            var type = parseInt(me.element.find("#div-settings .select-datatype").val());

            var val;

            switch (type) {
                case 1:    //mkorr;
                    val = me.element.find("#div-settings .txt-edit-value").val();
                    val = me.vcC.cleanNumber(val);
                    break;

                case 2:    //bdimsid;
                    val = me.element.find("#div-settings .select-dims").val();
                    break;

                case 3:    //hr datalevel;
                    val = me.element.find("#div-settings .select-level").val();
                    break;

                default:
            }


            var param = { typeid: 2, bsaid: me.settings.parameter.bsaid, day: me.currentDate, settings: { typeId: type, StartDate: me.settingDates.from, EndDate: me.settingDates.to, value: val.replace(",", ".") } }

            me.updateData(param, function (result) {
                if (result == null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return true;
                }
                if (result == false) {
                    me.showMessage(me.resources.err_saveData, true);
                    return true;
                }
                me._fetchSettings();
                me.openInfoDialog(me.specific.resources.dataSaved, { at: 'center center-20%', of: window });

                return true;
            });

        } catch (e) { me.writeError('save', e); return false; }
        return true;
    },

    _doEvent: function (event) {
        /// <summary>
        /// Handles different VCMQ messages
        /// </summary>
        var me = this;

        try {

            if (event !== null) {

            

                switch (event.msg) {
                
                    case 'RAMP_EDIT_CLICK': //event when base chart point got clicked
                        
                        if (parseInt(event.vcgid) === parseInt(me.chartVcgid)) {

                            me._fetch(event.values.senderPoint.x);
                        }
                        break;

                    case 'RAMP_POINT_DROP': // event when edit chart point got dragged
                        me._setValueFromChartPoint(event.values.col, event.values.val);
                        break;

                    case 'CLOSE_EDIT_DIALOG':
                        me.editDialog.dialog("close");
                        me.divList.html("");
                        me._showBaseChart();
                        break;

                    case 'SIGNAL_ANALOG_DETAIL_CLOSE':
                        me.getConfigDirtyStatus();
                        break;

                    default:
                        break;
                }
            }
        } catch (ex) { me.writeError('doEvent', ex); }
    },

    getConfigDirtyStatus: function () {
        var me = this;

        try {
           
            window.VisualCoreService.getDataByName("VISUAL_UNIT_CONFIGCOMMIT", 'VUCC', getCurrentTimestamp(), 0, 0, JSON.stringify({ bsaid: me.settings.parameter.bsaid}), '', 2, '',
                function (result) {
                    me.fnd('#config-dirty-caption').removeClass("icon-color-error");
                    if (result == null) {
                        me.fnd('#config-dirty-caption').html("Config DIRTY").addClass("icon-color-error");
                    } else {
                        if (parseInt(result) === 0) {
                            me.fnd('#config-dirty-caption').html("Config OK");
                        } else {
                            me.fnd('#config-dirty-caption').html("Config DIRTY").addClass("icon-color-error");
                        }
                    }
                });

        } catch (ex) { me.writeError('getConfigDirtyStatus', ex); }


    },


   _sendTasks: function () {
        /// <summary>
        /// This function sends a task
        /// </summary>
        var me = this;
        try {

            var taskDates = me.fnd("#vc-cal-tasks").vcDate('getDate');
            var param = { typeid: 5, bsaid: me.settings.parameter.bsaid, day: me.currentDate, settings: { typeId: -1, StartDate: taskDates.from, EndDate: taskDates.to, value: parseInt(me.fnd("#ddl-send-tasks").val()) } }

            me.getData(param, function (result) {

                //check response content
                if (result == false) {
                    me.showMessage(me.resources.err_loadData, true);
                    return true;
                }
                alert(me.specific.resources.done + "!");
            
            });

        } catch (e) { me.writeError('_sendTasks', e); return false; }
        return true;
    },

    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) {
                me.fnd("#div-menu, #div-chart, #div-settings").hide();
            }
            return true;
        } catch (e) {
            me.writeError('specificInfoHandling', e); return false;
        }
    },

    dispose: function () {
        var me = this;
        try {
            me.element.removeClass("ds-edit2").html("");
            me.divList = null;
        
          
        } catch (e) {
            me.writeError('dispose', e); return false;
        }
    }
    ,destroy: function () {

        this._super();
    }

});

$.widget("bluaul.DsEditRaw2", $.bluaul.DsEditTemplate2, {
      /// <summary>
        /// Inherits the base widget by extended and customized functions for the raw/archive data
        /// </summary>
    vcgid: 326,
    colWidth: 270,
    rowHeightFactor: 1,
    settingsListDateFormat: "DD.MM.YYYY HH:mm:ss",

    _showBaseChart: function () {
        /// <summary>
        /// This function loads the chart
        /// </summary>
        var me = this;
     
        try {
            me.fnd("#div-info-hrbased").hide();

            me.fnd("#div-bottom-frame").hide();
            me.fnd("#div-chart, #div-right-frame").height(me.chartHeight);
           

            var param = {'Interval': 10, 'highresolutionasrawdata': false, 'MqEventOnPointClick': true, 'MqEventName': "RAMP_EDIT_CLICK",'FixTooltip': false}
            me.chartVcgid = me._showChart(999990,me.fnd("#div-chart"),  "VISUAL_RAMP_HR",param, me.settings.parameter.bsaid, me.currentDate , false, false);
            return true;

        } catch (e) { me.writeError('showChart', e); return false; }
        return true;
    },

    _getSelectedIndex: function (selectedChartIndex) {
        /// <summary>
        /// converts the selected chart index to the according index in the edit list
        /// </summary>
        var me = this;
        try {

            //get the selected index of the timestamp from the data list
            var timestamp = moment(new Date(selectedChartIndex)).utc().format('DD.MM.YYYY HH:mm:ss');

            var selectedIndex = 0;
            for (var i = 0; i < me.data.length; i++) {
                if (timestamp == me.data[i].Timestamp) { selectedIndex = i;}
            }

            return selectedIndex;

        } catch (ex) { me.writeError('getSelectedIndex', ex); return 0; }
    },


    _addLine: function (row, selected) {
        /// <summary>
        /// generates one single entry
        /// </summary>
        var me = this;

        try {

            var t = moment(row.Timestamp, 'DD.MM.YYYY HH:mm:ss').format('HH:mm:ss');
            var dt = moment(row.Timestamp, 'DD.MM.YYYY HH:mm:ss').format('DD.MM.YYYY');

            var line = $("<div>").data("date", dt).addClass("line");
            if (selected) {
                line.addClass("selected");
            }
            var time = $("<span>").addClass("time").html(t + " h");
            var val = Highcharts.numberFormat(row.Value, me.digitNumber, ',', '');
            var input = $("<input>").prop("required", "required").addClass("val txtEnabled").data("oldVal", val).data("id", row.Id).val(val);
            var mkorr = $("<span>").addClass("mkorr").html(Highcharts.numberFormat(row.Mkorr, me.digitNumber, ',', ''));
            var chk = $("<input>").prop("type", "checkbox").addClass("chk").data("oldVal", row.Ignore).prop("checked", row.Ignore);

            ////we hide the ignore checkbox if we are not allowed to ignore values
            if (!me.specific.allowIgnoredValues) {chk.hide(); }

            var icon = $("<span>").addClass("icon icon-color-info").data("id", row.Id);

            line.append(chk, time, input, mkorr, icon);
            return line;
        } catch (ex) { me.writeError('_addLine', ex); return ""; }
    },

    _addHeader: function (text, date) {
        /// <summary>
        /// header for each column
        /// </summary>
        var me = this;
        try {

            var line = $("<div>").data("date", date).addClass("line vc-list-header-simple");
            ////we hide the ignore checkbox if we are not allowed to ignore values
          
                if (!me.specific.allowIgnoredValues) {
                    line.html("time/value/mkorr");
                } else {
                    line.html("ignore/time/value/mkorr");
                }
          
            return line;
        } catch (ex) { me.writeError('_addHeader', ex); return ""; }
    },



});

$.widget("bluaul.DsEditArchive2", $.bluaul.DsEditTemplate2, {
    /// <summary>
    /// Inherits the base widget by extended and customized functions for the archive data
    /// It contains the list editor and an editional chart editing function (incl. a data copy functionality )
    /// </summary>
    vcgid: 327,
    colWidth: 220,
    rowHeightFactor: 0.5,
    settingsListDateFormat: "DD.MM.YYYY",
    copyDate: null,
    initCopyDate: false,
    zstDiff: 0,
    noZstDiffAvailable: true,
    archiveSum: 0,
    showFirstCol: 0,
    dailyCols: 0,
    moveColsAtOnce:3,
    shiftArchiveIndex: 96, //we have to shift the archive index as we always start with the previous day in our data
    _addEditFormMenuAndValidation: function () {
        /// <summary>
        /// Extends the base function by the copy menu functions
        /// </summary>
        var me = this;
        var w, h;
        try {

            me._super();

            me.editDialog.find("#div-edit-list-menu").show();

            //init the move menu
            me.editDialog.find("#div-edit-list-menu .move.button-toggle").off("click").on("click", function () { me._moveEditMenu($(this)); });

            //init the edit menu
            me._toggleEditMenu(me.editDialog.find("#div-edit-list-menu .types.button-toggle:first"));
            me.editDialog.find("#div-edit-list-menu .types.button-toggle").off("click").on("click", function () { me._toggleEditMenu($(this)); });

            //init the copy functions
            var div = me.editDialog.find("#div-edit-chart-bottom");
            div.find('#div-copy-chart').height(parseInt(div.height() - div.find('#div-copy-menu').height() - 40));


            div.find("#ddl-copy-signals").val(me.settings.parameter.bsaid).off("change").on("change", function () { me._showCopyChart() });
            var btnCopy = div.find("#div-btn-copy").button();
            btnCopy.off("click").on("click", function () {
                me._fetchCopyValues();
            });

            me.editDialog.find("#div-edit-list-menu #div-zst-diff .txtEnabled").off("keyup").on("keyup", function () {
                me._calcNewZstMenu(false);
            });



        } catch (ex) { me.writeError('_addEditFormMenuAndValidation', ex); return ""; }
    },


    _showBaseChart: function () {
        /// <summary>
        /// This function loads the chart
        /// </summary>
        var me = this;

        try {



            if (me.specific.isHrBased) {
                me.fnd("#div-info-hrbased").show();
                me.fnd("#div-info-hrbased").removeClass("icon-color-error");
                if (moment().diff(moment(me.currentDate, 'DD.MM.YYYY'), 'days') <= 3) {
                    me.fnd("#div-info-hrbased").addClass("icon-color-error");
                }
            } else {
                me.fnd("#div-info-hrbased").hide();
            }
            //moment(me.currentDate, 'DD.MM.YYYY').add(-31, 'd')

            //me.fnd("#div-bottom-frame").hide();
            me.fnd("#div-chart, #div-right-frame").height(me.chartHeight);
            me.fnd("#div-chart,#div-right-frame").height(me.fnd("#div-chart").height() - me.fnd("#div-bottom-frame").height() - 10);

            me.fnd("#div-bottom-frame").show();


            var param = { 'Interval': 1, 'MqEventOnPointClick': true, 'MqEventName': "RAMP_EDIT_CLICK", 'FixTooltip': false, 'MarkInplausibleValues': true, HideNotAllowedIntervals: false }
            me.chartVcgid = me._showChart(999990, me.fnd("#div-chart"), "VISUAL_RAMP_SINGLE", param, me.settings.parameter.bsaid, me.currentDate, false, false);


            var divBottomFrame = me.fnd("#div-bottom-frame");

            divBottomFrame.html(me.vcC.getLoadingIcon());

            //we delay the loading of the additional charts as we want the main chart to be first
            setTimeout(function () {



                me.chartBottomLeft = {}
                me.chartBottomLeft.random = 999992;
                me.chartBottomLeft.prefix = divBottomFrame.attr("id") + "-1-";
                me.chartBottomLeft.obj = $("<div>").attr("id", me.chartBottomLeft.prefix + me.chartBottomLeft.random);

                me.chartBottomLeft.obj.css("float", "left");
                divBottomFrame.html(me.chartBottomLeft.obj);

                me.chartBottomLeft.obj.width(parseInt(divBottomFrame.width() * 0.65));
                me.chartBottomLeft.obj.height(parseInt(divBottomFrame.height()));

                var dtStart = moment(me.currentDate, 'DD.MM.YYYY').add(-31, 'd').format('DD.MM.YYYY');
                var dtEnd = moment(me.currentDate, 'DD.MM.YYYY').add(3, 'd').format('DD.MM.YYYY');

                var param1 = { LoggerID: me.settings.parameter.LoggerId, DataType: 2, StartDate: dtStart, EndDate: dtEnd, DateuserDef: true, ShowZstDiffChartForDailyValues: true, UseSimpleBottomLegend: true, FixTooltip: true, NoZoom: false }



                //console.info(param1);
                //console.info(me);
                //console.info(me.settings.parameter.bsaid);




                me.vcV.addRampBaseByName(me.chartBottomLeft.prefix, 'VISUAL_RAMP_DAILY', me.chartBottomLeft.random, me.currentDate, me.chartBottomLeft.obj.height(),
                    me.chartBottomLeft.obj.width(), JSON.stringify(param1), JSON.stringify({ 'series': [{ 'bsaid': [me.settings.parameter.bsaid], 'ruleType': 1, 'seriesType': 'column' }] }), me.settings.deviceType);

                //var c2 = me.getRandomIDContainerObj(divBottomFrame.attr("id") + "-2-", true);
                me.chartBottomRight = {}
                me.chartBottomRight.random = 999993;
                me.chartBottomRight.prefix = divBottomFrame.attr("id") + "-2-";
                me.chartBottomRight.obj = $("<div>").attr("id", me.chartBottomRight.prefix + me.chartBottomRight.random);
                me.chartBottomRight.obj.css("float", "left");
                divBottomFrame.append(me.chartBottomRight.obj);

                me.chartBottomRight.obj.width(parseInt(divBottomFrame.width() * 0.35));
                me.chartBottomRight.obj.height(parseInt(divBottomFrame.height()));

                param1.ShowZstForDailyValues = true;
                param1.ShowZstDiffChartForDailyValues = false;

                me.vcV.addRampBaseByName(me.chartBottomRight.prefix, 'VISUAL_RAMP_DAILY', me.chartBottomRight.random, me.currentDate, me.chartBottomRight.obj.height(),
                    me.chartBottomRight.obj.width(), JSON.stringify(param1), JSON.stringify({ 'series': [{ 'bsaid': [me.settings.parameter.bsaid], 'ruleType': 1 }] }), me.settings.deviceType);

            }, 2000);

            return true;

        } catch (e) { me.writeError('showBaseChart', e); return false; }
        return true;
    },


    _showEditForm: function (selectedChartIndex) {
        /// <summary>
        /// Opens the data editor popup
        /// </summary>
        var me = this;

        var i;
        try {

            if (me.specific.isRule) {
                alert(me.specific.resources.rulesCannotGetEdited);
                return;
            }

            me.divList.html("");

            //build the column list
            var cols = 18;

            me.dailyCols = 18 / 3;

            var rows = 96 / me.dailyCols;
            var lstCols = [];



            for (var i = 0; i < cols; i++) {
                var c = $("<div>").addClass("col");
                //we want to mark the second day
                if (i >= me.dailyCols && i < (me.dailyCols*2)) {
                    c.addClass("current-date");
                } else {
                    c.css("background-color", "#eee");
                }
                lstCols.push(c);

            }

            ////get the data index of the selected chart value
            var selectedIndex = me._getSelectedIndex(selectedChartIndex);

            //now we fill the list
            for (var j = 0; j < cols; j++) {
                if (((j * rows)) < me.data.length) {
                    var dt = moment(me.data[j * rows].Timestamp, 'DD.MM.YYYY HH:mm:ss').format('DD.MM.YYYY');
                    lstCols[j].append(me._addHeader(dt, dt));
                    for (i = 0; i < rows; i++) {
                        lstCols[j].append(me._addLine(me.data[(j * rows) + i], ((j * rows) + i) == selectedIndex));
                    }
                }
            }


            me.divList.html(lstCols);

            //we set the columns widths
            me.divList.find(".col").width(me.colWidth);

            me._showEditChart();

            me._initCopyDate();


            me.editDialog.dialog("open");


            me.showFirstCol = me.dailyCols;
            me.showHideCols();
            //when we reopen the edit form - we reset the menu to the edit list
            me._toggleEditMenu(me.editDialog.find("#div-edit-list-menu .types.button-toggle:first"));

        } catch (ex) { me.writeError('showEditForm', ex); }
    },


    _getSelectedIndex: function (selectedChartIndex) {
        return parseInt(selectedChartIndex) + this.shiftArchiveIndex;
    },

    _addLine: function (row, selected) {
        /// <summary>
        /// generates one single entry
        /// </summary>
        var me = this;

        try {

            var t = moment(row.Timestamp, 'DD.MM.YYYY HH:mm:ss').format('HH:mm');
            var dt;
            if (t == "00:00") {
                dt = moment(row.Timestamp, 'DD.MM.YYYY HH:mm:ss').add(-1, "days").format('DD.MM.YYYY');
            } else {
                dt = moment(row.Timestamp, 'DD.MM.YYYY HH:mm:ss').format('DD.MM.YYYY');
            }

            var line = $("<div>").data("date", dt).addClass("line");
            if (selected) {
                line.addClass("selected");
            }
            var time = $("<span>").addClass("time").html(t + " h");
            var val = "";

            if (row.Value != null) {
                val = Highcharts.numberFormat(row.Value, me.digitNumber, ',', '');
            }

            var input = $("<input>").prop("required", "required").addClass("val txtEnabled").data("oldVal", val).data("id", row.Id).val(val);

            if (row.Value == null) { input.addClass("empty"); }

            var icon = $("<span>").addClass("icon icon-color-info").data("id", row.Id);

            if (row.Value != null && !row.Plausible) {
                icon.append(me.specific.resources.iconPlausibility);
            }


            line.append(time, input, icon);
            return line;
        } catch (ex) { me.writeError('_addLine', ex); return ""; }
    },

    _addHeader: function (text, date) {
        /// <summary>
        /// header for each column
        /// </summary>
        var me = this;

        try {
            return $("<div>").data("date", date).addClass("line vc-list-header-simple").html(text);

        } catch (ex) { me.writeError('_addHeader', ex); return ""; }
    },

    showHideCols: function (obj) {
        /// <summary>
        /// This function 
        /// </summary>
        var me = this;
        try {
            var i = 0;
            $.each(me.divList.find(".col"), function () {
                if ((i >= me.showFirstCol) && (i < (me.showFirstCol + me.dailyCols))) {
                    $(this).show();
                } else {
                    $(this).hide();
                }
                i++;
            });

        } catch (e) { me.writeError('showHideCols', e); return false; }
        return true;
    },

    _moveEditMenu: function (obj) {
        /// <summary>
        /// This function shows/hides divs when changing between chart and settings
        /// </summary>
        var me = this;
        try {

            

            if (obj.attr("id") == "div-btn-move-left") {
              
                if (me.showFirstCol >= me.moveColsAtOnce) {
                    me.showFirstCol = me.showFirstCol - me.moveColsAtOnce;
                    me.showHideCols();
                }
                if (me.showFirstCol == 0) obj.addClass("inactive");
                me.editDialog.find("#div-btn-move-right").removeClass("inactive");
            } else {
               
                if (me.showFirstCol <= (me.divList.find(".col").length - (me.dailyCols + me.moveColsAtOnce))) {
                    me.showFirstCol = me.showFirstCol + me.moveColsAtOnce;
                    me.showHideCols();
                } else {
                    obj.addClass("inactive");
                }

                if ((me.showFirstCol + me.dailyCols) == me.divList.find(".col").length) obj.addClass("inactive");
                me.editDialog.find("#div-btn-move-left").removeClass("inactive");
            }

        } catch (e) { me.writeError('_moveEditMenu', e); return false; }
        return true;
    },


    _toggleEditMenu: function (obj) {
        /// <summary>
        /// This function shows/hides divs when changing between chart and settings
        /// </summary>
        var me = this;
        try {

            me.editDialog.find("#div-edit-list-menu .types.button-toggle").removeClass("button-toggle-active");
            obj.addClass("button-toggle-active");
            if (obj.attr("id") == "div-btn-list") {
                me.divList.show();
                me.divChart.hide();
            } else {
                me.divList.hide();
                me.divChart.show();
                me._showCopyChart();
            }

        } catch (e) { me.writeError('_toggleEditMenu', e); return false; }
        return true;
    },

    _showEditChart: function () {
        /// <summary>
        /// This function loads the edit chart - in this chart we can edit the values directly by drag and drow
        /// </summary>
        var me = this;

        try {

            var param = {
                'Interval': 1, 'EditMode': true, 'isArchive': false,
                'DecimalPlace': 3, 'HideNotAllowedIntervals': false, 'LimitMinToNull': false, 'ExternalTooltip': true, 'fixTooltip': true
            }

            me.editChartVcgid = me._showChart(999994,me.editDialog.find("#div-edit-chart-top"), "VISUAL_DATACENTER_SINGLE_EDIT", param, me.settings.parameter.bsaid, me.currentDate, true, true);

            return true;

        } catch (e) { me.writeError('showEditChart', e); return false; }
        return true;
    },

    _setValueFromChartPoint: function (col, val) {
        /// <summary>
        /// This function gets a value from a chart point, finds the according entry in the edit list and updates it
        /// </summary>
        var me = this;

        try {

            var index = me._getSelectedIndex(col);
            
            me.divList.find('.current-date .val').each(function (e) {

                if ($(this).data("id") == index) {
                    $(this).val(val);
                    if (me._validate($(this))) {
                        me.btnSave.button("enable");
                    } else {
                        me.btnSave.button("disable");
                    }
                    return false;
                }
            });
        } catch (e) { me.writeError('_setValueFromChartPoint', e); return false; }
        return true;
    },

    _setChartPointFromValue: function (row, val) {
        /// <summary>
        /// This function sets a new value in the edit chart
        /// </summary>
        var me = this;
        try {
            _VCMQ.produce($(me.visual), me.options.invoke.vcgid, 'RAMP_EDIT_SET_POINT', { target: me.editChartVcgid, index: 0, row: row, val: val });

        } catch (e) { me.writeError('_setChartPointFromValue', e); return false; }
        return true;
    },



    _initCopyDate: function () {
        /// <summary>
        /// This function loads the copy chart
        /// </summary>
        var me = this;
        try {

            var copyDate = me.editDialog.find("#div-edit-chart-bottom #div-copy-date");


            var prevDay = moment(me.currentDate, 'DD.MM.YYYY').add(-1, 'd').format('DD.MM.YYYY');
           

            if (copyDate.html().length > 0) { copyDate.vcDate("destroy") };
            copyDate.vcDate({
                mode: 'Single', align: 'right', interval: 1, langID: me.settings.userLangID, defaultDate: prevDay, callback: function (obj) {
                    me.copyDate = obj.singleDate;
                    if (me.initCopyDate) me._showCopyChart();
                    me.initCopyDate = true;

                }
            });


        } catch (e) { me.writeError('_initCopyDate', e); return false; }
        return true;
    },


    _showCopyChart: function () {
        /// <summary>
        /// This function loads the copy chart
        /// </summary>
        var me = this;
        try {

            me.copyBsaid = parseInt(me.editDialog.find("#ddl-copy-signals").val());
            var param = { 'Interval': 1, 'FixTooltip': false }
            me.copyChartVcgid = me._showChart(999995,me.editDialog.find("#div-copy-chart"), "VISUAL_RAMP_SINGLE", param, me.copyBsaid, me.copyDate, false, true);
            return true;

        } catch (e) { me.writeError('_showCopyChart', e); return false; }
        return true;
    },

    _fetchCopyValues: function () {
        /// <summary>
        /// This function fetches the data we want to copy based on the copy menu
        /// </summary>
        var me = this;
        try {
          
            var param = { typeid: 1, bsaid: me.copyBsaid, day: me.copyDate,  LoadOnlySingleDay: true }

            me.getData(param, function (result) {
                //check response content
                if (result == null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return true;
                }
                me._copyValues(result);

                return true;
            });

        } catch (e) { me.writeError('fetchCopyValues', e); return false; }
        return true;
    },

    _copyValues: function (data) {
        /// <summary>
        /// This function decides which values should get copied based on the copy menu
        /// </summary>
        var me = this;
        var index = 0;
        var overwrite = false;
        var newVal = 0;
        var val = 0;
        try {

            var copyType = parseInt(me.editDialog.find("#ddl-copy-type").val());
            var startIndex = parseInt(me.editDialog.find("#ddl-copy-from").val());
            var endIndex = parseInt(me.editDialog.find("#ddl-copy-to").val());

            me.divList.find('.current-date .val').each(function (e) {
                index = parseInt($(this).data("id")) - me.shiftArchiveIndex;
                val = parseFloat($(this).val());

                if ((index + 1) >= startIndex && (index + 1) <= endIndex) {
                    overwrite = false;
                    switch (copyType) {
                        case 1: //overwrite empty values
                            if (isNaN(val)) {
                                newVal = me._getValFromCopyData(data, index);
                                overwrite = (newVal !== null);
                            }
                            break;
                        case 2: //overwrite 0 values
                            if (isNaN(val) == false) {
                                if (val == 0) {
                                    newVal = me._getValFromCopyData(data, index);
                                    overwrite = (newVal !== null);
                                }
                            }
                            break;
                        case 3: //overwrite empty and 0 values
                            if (isNaN(val) || val == 0) {
                                newVal = me._getValFromCopyData(data, index);
                                overwrite = (newVal !== null);
                            }
                            break;
                        case 4: //overwrite all values
                            newVal = me._getValFromCopyData(data, index);
                            overwrite = (newVal !== null);
                            break;
                        case 5: //overwrite all values with 0
                            overwrite = true;
                            newVal = 0;
                            break;
                        case 6: //overwrite empty values with 0
                            if (isNaN(val) || val == 0) {
                                overwrite = true;
                                newVal = 0;
                            }
                            break;
                        default:
                    }


                    if (overwrite) {
                        $(this).val(Highcharts.numberFormat(newVal, me.digitNumber, ',', ''));
                        if (me._validate($(this))) {
                            me.btnSave.button("enable");
                        } else {
                            me.btnSave.button("disable");
                        }
                        //send the value to the edit chart to update this one too

                        me._setChartPointFromValue(parseInt($(this).data("id")) - me.shiftArchiveIndex, newVal);
                    }

                }
            });


        } catch (e) { me.writeError('fetchCopyValues', e); return false; }
        return true;
    },

    _getValFromCopyData: function (data, index) {
        /// <summary>
        /// This function returns a value for a given index form the copy data
        /// </summary>
        var me = this;
        var val = null;
        try {
            for (var i = 0; i < data.length; i++) {
                if (data[i].Id === index) { return data[i].Value; }
            }

        } catch (e) { me.writeError('getValFromCopyData', e); return null; }
        return null;
    },



    _getZstDiff: function () {
        /// <summary>
        /// This function fetches the current zst diff for the archive day
        /// </summary>
        var me = this;
        try {
            var param = { typeid: 4, bsaid: me.settings.parameter.bsaid, day: me.currentDate }
            me.zstDiff = 0;
            me.getData(param, function (result) {
                //check response content
                if (result == null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return true;
                }
                me.editDialog.find("#div-zst-diff").show();

                if (result.rows == null) {
                 
                    me.editDialog.find("#span-zst-caption").html(me.specific.resources.difference);
                    me.noZstDiffAvailable = false;
                    me._calcNewArchiveSum();
                    me.zstDiff = me.archiveSum;
                    me.editDialog.find("#txt-zst-diff").val(Highcharts.numberFormat(me.zstDiff, me.digitNumber, ',', ''));

                    me._calcNewArchiveSum();
                    return true;
                } 
                if (me.editDialog.find(".current-date .val").length !== 96) {
                    me.editDialog.find("#div-zst-diff").html(me.specific.resources.showZstCalcOnFullData);
                    me.zstDiff = 0;
                    me.noZstDiffAvailable = true;
                    return true;
                }
                me.noZstDiffAvailable = false;
                me.editDialog.find("#span-zst-caption").html(me.specific.resources.zstDifference + "(" + moment(new Date(result.rows[0].prevday)).format('DD.MM.YYYY') + ")");


                me.zstDiff = result.rows[0].zstdiff * result.rows[0].mkorr_single;
                me.editDialog.find("#txt-zst-diff").val(Highcharts.numberFormat(me.zstDiff, me.digitNumber, ',', ''));

                me._calcNewArchiveSum();

                return true;
            });

        } catch (e) { me.writeError('_getZstDiff', e); return false; }
        return true;
    },

    _calcNewArchiveSum: function () {
        /// <summary>
        /// This function recalculates the new archive sum, based on the current input
        /// </summary>
        var me = this;
        try {
            me.archiveSum = 0;
            var sum = 0;

            me.editDialog.find(".current-date .val").each(function () {

                if ($(this).val().length > 0) {
                    sum += parseFloat($(this).val().replace(",", "."));
                }
            });

            me.archiveSum = sum;
            me.editDialog.find("#txt-archiv-sum").val(Highcharts.numberFormat(sum, me.digitNumber, ',', ''));
             me._calcNewZstMenu(true);
        } catch (e) { me.writeError('_calcNewArchiveSum', e); return false; }
        return true;
    },


    _calcNewZstMenu: function (bRecalc) {
        /// <summary>
        /// This function recalcutates the zst-diff menu entries - either based on the manual input or the changes in the archive values
        /// </summary>
        var me = this;
        var zstDiff, sum;
        try {
          
        
            if (me.noZstDiffAvailable) return true;

            if (bRecalc) {
                zstDiff = me.zstDiff;
                sum = me.archiveSum;
            } else {
                zstDiff = parseFloat(me.editDialog.find("#txt-zst-diff").val().replace(",", "."));
                sum = parseFloat(me.editDialog.find("#txt-archiv-sum").val().replace(",", "."));
            }

            var dif = zstDiff - sum;

            me.editDialog.find("#txt-zst-failure").val(Highcharts.numberFormat(dif, me.digitNumber, ',', ''));
            me.editDialog.find("#txt-zst-failure").removeClass("err")
            if (dif !== 0) {
                me.editDialog.find("#txt-zst-failure").addClass("err");
            }
            dif = dif / parseFloat(me.editDialog.find("#txt-zst-split").val().replace(",", "."));
            me.editDialog.find("#txt-zst-split-single").val(Highcharts.numberFormat(dif, me.digitNumber, ',', ''));

        } catch (e) {
         
            me.writeError('_calcNewZstMenu', e); return false;
        }
        return true;
    }
    , destroy: function () {

        this._super();
    }
});

